import React, { useMemo } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { findArray, filterArray } from 'helpers/utils'
import { ColumnStartOrder, ColumnResult, ColumnName, ColumnNoc, ColumnTeamComponents } from "components/common/TableColumns"
import MirsTable from "components/general/table/Table";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function getColumns(current) {
    return (
        [
            ColumnStartOrder({ disableSort: true }),
            ColumnNoc({ label: "", disableSort: true }),
            ColumnTeamComponents({ disableSort: true }),

            {
                Header: <><Label data='HeaderRound' /> {current}</>,
                id: 'CurrentData1',
                accessor: 'participant.code',
                className: 'text-start',
                headerClassName: 'text-start',

                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['DESC'] })
                    let type = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['TYPE'] })
                    let dd = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['DD'] })
                    let valType = (type?.eue_value === 'A')
                        ? <Label data="LabelStraight" />
                        : type.eue_value === 'B' ? <Label data="LabelPike" />
                            : type.eue_value === 'C' ? <Label data="LabelTuck" />
                                : type.eue_value === 'D' ? ''
                                    : ''
                    return (
                        <>  <div><strong><Label data='HeaderDescription' />:</strong> {num?.eue_value}</div>
                            <div><strong><Label data='HeaderPosition' />:</strong> {valType}</div>
                            <div><strong><Label data='HeaderDD' />:</strong> {dd?.eue_value}</div>
                        </>
                    )
                }

            },

            {
                Header: <Label data='HeaderAverageJudges' />,
                id: 'CurrentData2',
                accessor: 'participant.code',
                className: 'text-start',
                headerClassName: 'text-start',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['SCORE'] })

                    let rank = filterArray(num?.extensions, { ere_code: ['AVG_NEED'] }).sort((a, b) => a.ere_pos - b.ere_pos)

                    return (
                        <>
                            {
                                rank?.map((item, key) => {
                                    return (
                                        <div key={'rank-need-' + item.ere_pos}><strong><Label data='HeaderRank' /> {item.ere_pos}:</strong> {item?.ere_value}</div>
                                    )
                                })
                            }

                        </>
                    )
                }
            }

        ]
    )
}

export function getColumnsXS() {
    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
        ]
    )
}

const CurrentCompetitor = ({ data }) => {
    const { breakPoint } = useViewport();
    let columns
    if (breakPoint === "xxl" || breakPoint === "xl" || breakPoint === "lg" || breakPoint === "md") {
        columns = getColumns(data.currentSplit)
    } else {
        columns = getColumnsXS()
    }
    const configCurrent = useMemo(() => columns, [data.currentSplit, breakPoint]);
    const { mirs_rsc } = useUrlFriendlyToParameters()
    return (
        <div className="mirs-page-container-current">
            < MirsTable
                className='table-result'
                data={[data]}
                columns={configCurrent}
                keyRow='participant-code'
                caption={<Label data='HeaderCurrentTeam' />}
                id={`mirs-table-result1-${mirs_rsc}`}
            />
        </div>
    );
}

export default CurrentCompetitor;